import React from 'react';
import './ButtonRegular.css';

const ButtonRegular = ({ children, className = '', type = 'button', onClick, disabled = false, ariaLabel }) => {
	return (
		<button
			type={type}
			className={`btn-regular ${className}`}
			onClick={onClick}
			disabled={disabled}
			aria-label={ariaLabel}
		>
			{children}
		</button>
	);
};

export default ButtonRegular;
